import { useCallback } from "react";

type ReturnType = {
  type: "error" | "success";
  message: unknown;
};
type CopyFn = (text: string) => Promise<ReturnType>;

function useCopyToClipboard(): CopyFn {
  const copy: CopyFn = useCallback(async (text) => {
    if (!navigator?.clipboard) {
      return { type: "error", message: "Clipboard not supported" };
    }
    try {
      await navigator.clipboard.writeText(text);
      return { type: "success", message: "" };
    } catch (error) {
      return { type: "error", message: error };
    }
  }, []);

  return copy;
}

export default useCopyToClipboard;
